<template>
  <SplashWrapper
    :hide-buttons="true"
    :hide-logo="isExpert"
    title="Two-factor authentication"
    :narrow-page="true"
  >
    <iColumn gap="extraLarge">
      <iRow>
        <iText variant="subtle">
          Enter the code from your authenticator app, or one of your backup codes.
        </iText>
      </iRow>

      <iRow>
        <iColumn>
          <iTextInput
            ref="code"
            v-model="code"
            :focus="true"
            label-position="above"
            label="Authentication or backup code: "
            width="fill"
            name="mfa-code"
            @enter="submitCode"
          />

          <iText v-if="twoFactorErrorMessage" variant="error">
            {{ twoFactorErrorMessage }}
          </iText>

          <iButton
            variant="primary"
            type="submit"
            width="fill"
            :disabled="!code"
            :is-loading="isLoading"
            loading-spinner-position="inside"
            @click="submitCode"
          >
            Verify
          </iButton>

          <iButton
            v-if="hasPasskey"
            variant="secondary"
            type="button"
            width="fill"
            left-icon="key"
            :is-loading="isLoading"
            @click="submitPasskey"
          >
            Use a passkey
          </iButton>
        </iColumn>
      </iRow>
    </iColumn>
  </SplashWrapper>
</template>

<script>
import { mapActions, mapState, mapWritableState } from "pinia";
import { useUserStore } from "@/stores/user-store";
import SplashWrapper from "@/components/splash/SplashWrapper";

export default {
  name: "TwoFactorForm",
  components: { SplashWrapper },
  inject: ["intent"],
  data() {
    return {
      code: "",
    };
  },
  computed: {
    ...mapWritableState(useUserStore, ["twoFactorErrorMessage"]),
    ...mapState(useUserStore, ["isLoading", "mfaMethods"]),
    hasPasskey() {
      return this.mfaMethods.includes("passkey");
    },
    isExpert() {
      return this.intent === "expert";
    },
  },
  mounted() {
    this.twoFactorErrorMessage = "";
  },
  methods: {
    ...mapActions(useUserStore, ["verifyCode", "verifyPasskey"]),
    submitCode() {
      if (!this.code) {
        return;
      }
      this.verifyCode(this.code);
    },
    submitPasskey() {
      this.verifyPasskey();
    },
  },
};
</script>

<style lang="scss" scoped></style>
